import * as singleSpa from "single-spa";
import {
  logger,
  isLogged,
  getIsLoggedRoute,
  ROUTES,
  onErrorBoundary,
  APPS,
} from "@creditas/home-mf-shared";
import { ROOT_LOG_PREFIX } from "./consts";
import { getLastLeadRetry } from "./getLastLeadRetry";
import { getCurrentCustomer } from "../services";

export const isLoggedRoute = getIsLoggedRoute();

export function getOriginalPath(pathname: string) {
  return pathname[pathname.length - 1] === "/"
    ? pathname.substring(0, pathname.length - 1)
    : pathname;
}

export function activeWhenHelper(locationCheck) {
  return isLoggedRoute ? locationCheck() && isLogged() : locationCheck();
}

function stillOnGoing() {
  logger.info({
    message: `[${ROOT_LOG_PREFIX}][CHECK_LEAD_ACTIVINESS] Started singleSPA root`,
  });
  singleSpa.start({ urlRerouteOnly: true });
}

function preQualificationRefusedReason() {
  logger.info({
    message: `[${ROOT_LOG_PREFIX}][CHECK_LEAD_ACTIVINESS][REDIRECT] PQ refused and redirect to PQ page`,
  });
  window.location.assign(ROUTES.PRE_QUALIFICATION);
}

function unknowActivenessReason() {
  logger.info({
    message: `[${ROOT_LOG_PREFIX}][CHECK_LEAD_ACTIVINESS][REDIRECT] Redirected to dashboard`,
  });
  window.location.assign(ROUTES.DASHBOARD);
}

const checkActiveUseCase = {
  STILL_ONGOING: stillOnGoing,
  PRE_QUALIFICATION_REFUSED_REASON: preQualificationRefusedReason,
  UNKNOWN_ACTIVENESS_REASON: unknowActivenessReason,
};

const RETRY_GET_ACTIVE_LEAD = 5;
export async function checkLead() {
  try {
    const { customerId } = await getCurrentCustomer();
    if (!customerId) throw new Error("Customer id not found!");

    const { isActive, description } = await getLastLeadRetry(
      customerId,
      RETRY_GET_ACTIVE_LEAD
    );

    logger.info({
      message: `[${ROOT_LOG_PREFIX}][CHECK_LEAD_ACTIVINESS] isActive: ${isActive}`,
      body: { isActive, description },
    });

    const action = description ?? "UNKNOWN_ACTIVENESS_REASON";
    checkActiveUseCase[action]();
  } catch (error) {
    if (error?.status === 401) return;
    logger.error({
      message: `[${ROOT_LOG_PREFIX}][CHECK_LEAD_ACTIVINESS][REDIRECTED] an error occurred! redirected to dashboard.`,
      error: JSON.stringify(error) as any,
    });
    window.location.assign(ROUTES.DASHBOARD);
  }
}

export function addErrorHandler() {
  const loadingErrorCount = {};
  const loadingStatus = [singleSpa.LOAD_ERROR, singleSpa.LOADING_SOURCE_CODE];

  singleSpa.addErrorHandler((err) => {
    const shouldReloadPage = loadingErrorCount[err.appOrParcelName] === 1;
    const shouldRetryApp = loadingStatus.includes(
      singleSpa.getAppStatus(err.appOrParcelName)
    );

    if (shouldReloadPage) {
      onErrorBoundary({
        appName: "home-mf-root",
        error: { message: err.toString() },
        redirectTo: window.location.pathname.startsWith(APPS.RESUME.route)
          ? "/dashboard"
          : APPS.RESUME.route,
      });
    } else if (shouldRetryApp) {
      System.delete(System.resolve(err.appOrParcelName));
      loadingErrorCount[err.appOrParcelName] = 1;
    }
  });
}
